import React from 'react';
import Seo from '@/components/Seo';
import { Origins as GlobalOrigins } from '@/components/origins';
import { originsContent } from '@/content/origins';

/**
 * Standalone "Origins" page, linked from the navbar's "Origins" entry
 * (see `siteConfig.pages`). Reuses the home page's "Global Origins" section
 * component as-is, so the content/markup stays in sync wherever it's
 * rendered — it is not removed from the home page (see `Home.tsx`), only
 * additionally reachable via this dedicated page.
 */
const Origins: React.FC = () => {
    return (
        <>
            <Seo title={originsContent.sectionTitle} path="/origins" breadcrumbs={[]} />
            <GlobalOrigins />
        </>
    );
};

export default Origins;
